/**
 * Flight Feature Constants
 *
 * Centralized constants for the flight feature module
 */

import type {
    DroneOption,
    FlightSetupFormData,
} from './types/flight.types';

/**
 * Mock drone data
 */
export const DRONE_OPTIONS: DroneOption[] = [
    { value: 'pyrhos-x-v1-100', label: 'Pyrhos X V1 (Aerial) - Battery: 100%' },
    { value: 'pyrhos-x-v1-85', label: 'Pyrhos X V1 (Aerial) - Battery: 85%' },
    { value: 'dji-matrice-300', label: 'DJI Matrice 300 - Battery: 92%' },
];

/**
 * Mock aoi data
 */
export const AOI_OPTIONS: DroneOption[] = [
    { value: 'sector-5', label: 'Sector 5' },
    { value: 'grid-a-12', label: 'Grid A 12' },
];

/**
 * Default form values for flight setup
 */
export const DEFAULT_FLIGHT_VALUES: FlightSetupFormData = {
    flightName: '',
    selectMission: '',
    selectAOIs: [],
    selectPilot: '',
    aiEnabled: false,
    flightDescription: '',
};
